import React from "react";
import { EcoRadar } from "./EcoRadar";
import { EcoTicker } from "./EcoTicker";
import { getRadarData } from "./radarData";

// Panel derecho "La Brújula" — alternativa al carrusel 3D (EcosystemPanel),
// elegida al azar por visita en Auth.js. Comparte el encabezado/pie con la
// versión carrusel (mismas claves de traducción eco_*, ver README de
// design_handoff_sustemia_login); el radar y el ticker son propios de esta
// versión, ver radarData.js.
export function BrujulaPanel({ t, language }) {
  const data = getRadarData(language);

  return (
    <div className="eco-panel eco-panel--radar">
      <span className="eco-panel__star eco-panel__star--1" />
      <span className="eco-panel__star eco-panel__star--2" />
      <span className="eco-panel__star eco-panel__star--3" />

      <div className="eco-panel__header">
        <div>
          <div className="eco-panel__kicker">{t("eco_kicker")}</div>
          <h2 className="eco-panel__heading">
            {t("eco_heading_pre")}
            <span className="eco-panel__heading-highlight">
              {t("eco_heading_highlight")}
            </span>
          </h2>
        </div>
        <span className="eco-panel__count">{t("eco_modules_count")}</span>
      </div>

      <div className="eco-radar-body">
        <div className="eco-radar-body__text">
          <div className="eco-radar-body__headline">
            {data.headline.map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
            <span className="eco-radar-body__headline-highlight">
              {data.headlineHighlight.map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  {i < data.headlineHighlight.length - 1 && <br />}
                </React.Fragment>
              ))}
            </span>
          </div>
          <p className="eco-radar-body__subtitle">{data.subtitle}</p>
        </div>

        <EcoRadar blips={data.blips} />
      </div>

      <EcoTicker items={data.ticker} />

      <div className="eco-panel__footer">
        <span>{data.footerTagline}</span>
        <span className="eco-panel__footer-brand">{t("eco_footer_brand")}</span>
      </div>
    </div>
  );
}
